import styled from 'styled-components';

const Badge = styled.div`
    background: ${(props) => (props.backgroundColor)};
    color: ${(props) => (props.textColor)};
    font-size: 12px;
    font-weight: 600;
    text-transform: capitalize;
    padding: 4px 12px;
    border-radius: 12px;
    position: relative;
    display: inline-block;
`;

export default Badge;